import { appLanguages, type Locales } from "./i18n";
import { normalizeConditioning, toLotQuantity, toPhysicalPieceQuantity } from "./product-units";

export function formatProductQuantity(quantity: number, conditioning: unknown, locale: Locales) {
  const size = normalizeConditioning(conditioning);
  const units = toPhysicalPieceQuantity(quantity, conditioning);
  const dictionary: Record<string, string> = appLanguages[locale].locales;
  const unitKey = units === 1 ? "piece" : "pieces";
  if (size === 1) return `${units} ${dictionary[unitKey] || unitKey}`;
  const lots = toLotQuantity(quantity, conditioning);
  const template = dictionary[lots === 1 ? "{{ lots }} lot of {{ size }}" : "{{ lots }} lots of {{ size }}"];
  return template.replace("{{ lots }}", String(lots)).replace("{{ size }}", String(size));
}
